



















import { PropType } from 'vue';
import { FullEventModel } from '../../../../shared/models/fullEvent.model';

export default {
  props: {
    eventData: { type: Object as PropType<FullEventModel>, required: true },
  },
  computed: {
    content() {
      return this.eventData.description?.html ?? '';
    },
    isLesson() {
      return this.eventData.lesson != null;
    },
    noteToClass() {
      return this.eventData.lesson?.noteToClass?.html ?? '';
    },
    noteToTeacher() {
      return this.eventData.lesson?.noteToTeacher?.html ?? '';
    },
    noteToSubstitute() {
      return this.eventData.lesson?.noteToSubstitute?.html ?? '';
    },
    hasContent() {
      if (this.isLesson) {
        return Boolean(this.noteToClass || this.noteToTeacher || this.noteToSubstitute);
      }
      return Boolean(this.content);
    },
  }
};
